import React from 'react'

export const RightArrowIcon = ({fill}) => {
  return (
    <svg id="svg-close" xmlns="http://www.w3.org/2000/svg" height="30" width="30" viewBox="2 0 25 25">
      <path fill={fill ? fill : 'black'} d="M10 6 8.59 7.41 13.17 12l-4.58 4.59L10 18l6-6z"></path>
    </svg>
  )
}
